import React, { useEffect, useLayoutEffect, useState } from 'react'
import { Tooltip } from 'reactstrap';
interface ErrorTooltipType {
    message: any,
    target: any,
    open: any,
    key?: number | string,
    placement?: any
}
export default function ErrorTooltip(props: ErrorTooltipType) {
    const [tbottom, settbottom] = useState(false);
    const { message, target, open, key, placement = "bottom" } = props
    const [tooltipVisible, setTooltipVisible] = useState(false);
    useLayoutEffect(() => {
        setTooltipVisible(true);
    }, []);
    useEffect(() => {
        if (open && document.getElementById(target)) {
            const timeout = setTimeout(() => {
                setTooltipVisible(true);
                window.dispatchEvent(new Event('resize'));
            }, 1000);
            return () => clearTimeout(timeout);
        } else {
            setTooltipVisible(false);
        }
    }, [open, target]);
    return tooltipVisible ? (
        <Tooltip
            placement={placement}
            id={target}
            isOpen={open}
            target={target}
            toggle={() => {
                settbottom(!tbottom);
            }}
            style={{ background: '#fd625e' }}
            className='redArrow'
            key={key ?? "tooltip"}
        >
            <p style={{ color: 'white' }} className='mb-0'>{message}</p>
        </Tooltip>
    ) : null;
}
